import { get } from 'lodash';

import iosBridge from './iosBridgeService';
import * as bridgeActions from './actions';
import * as fromBridge from './constants';
import * as actions from '../main/payment/actions';
import * as fromPayment from '../main/payment/constants';
import * as tippingActions from '../register/tipping/actions';
import * as paymentActions from '../register/payment/actions';
import * as fromSettings from '../main/settings/constants';
import * as fromCashRegister from '../register/cashRegister/constants';
import * as fromAuth from '../auth/constants';
import * as fromTerminal from '../terminal/constants';
import * as fromWebreader from '../register/webReader/constants';
import * as webreaderActions from '../register/webReader/actions';
import { hideReceipt } from '../customer/receipts/actions';
import HttpV2 from '../httpv2';
import { showNotification } from '../common/helpers/notifications';
import { announceSlave } from '../listeningMode/actions';
import { nonBlockingHandoffActive } from '../listeningMode/selectors';
import { HANDOFF, HANDOFF_RESET_KIOSK_CART, HANDOFF_UPDATE_KIOSK_CART } from '../handoff/constants';
import * as handoffActions from '../handoff/actions';
import { showMessage } from '../listeningMode/messages/actions';
import { setSoldGiftCards } from '../register/giftCards/actions';
import { storeGiftCardCodes } from '../saleFlow/helpers';
import { publishToClient } from '../handoff/pubnub';
import { getCurrentUserId } from '../auth/selectors';
import { CHANGE_SHOP } from '../auth/constants';

export const handlePairing = (state, action, dispatch) => {
  switch (action.type) {
    case fromBridge.SLAVE_AVAILABLE:
      dispatch(announceSlave(action.payload.code, action.payload.id, action.payload.features));
      break;

    default:
  }
};

export const handleMessages = (action, dispatch) => {
  switch (action.type) {
    case fromBridge.SHOW_MESSAGE:
      dispatch(showMessage(action.payload));
      break;

    default:
  }
};

export const handleTipping = (state, action, dispatch) => {
  switch (action.type) {
    case fromBridge.TIPPING_DONE:
      dispatch(tippingActions.tippingDone(action.payload));
      break;

    case fromBridge.CLOSE_TIP_SCREEN:
      dispatch(actions.closeTipScreen());
      break;

    default:
  }
};

const completePayworksTransaction = transactionIdentifier => HttpV2.post(`/pos/complete/${transactionIdentifier}`);
const captureStripeTransaction = paymentIntentId => HttpV2.post(`/pos/capture/${paymentIntentId}`);
const completeTransaction = ({ transactionIdentifier, paymentIntentId }) => {
  if (transactionIdentifier) return completePayworksTransaction(transactionIdentifier);
  return captureStripeTransaction(paymentIntentId);
};

let handlerRegistered = false;
const registerHandler = (dispatch) => {
  if (!iosBridge.isInitialized() || handlerRegistered) {
    return;
  }

  iosBridge.registerHandler('payworks://close', (response = {}) => {
    if (!response.transactionIdentifier && !response.paymentIntentId) {
      dispatch(actions.paymentFailed());
      return;
    }

    if (response.giftCardName) {
      dispatch(setSoldGiftCards([{ name: response.giftCardName }]));
    }

    if (response.capture === false) {
      dispatch(actions.iosBridgePaymentSuccess(response.transactionIdentifier || response.paymentIntentId));
      return;
    }

    completeTransaction({
      transactionIdentifier: response.transactionIdentifier,
      paymentIntentId: response.paymentIntentId,
    })
      .then((apiResponse) => {
        dispatch(storeGiftCardCodes(apiResponse));
        dispatch(actions.iosBridgePaymentSuccess(response.transactionIdentifier || response.paymentIntentId));
      })
      .catch(({ message } = {}) => {
        showNotification({
          title: 'ERROR',
          level: 'error',
          message: message || 'Unknown error occurred',
        });
        dispatch(actions.paymentFailed());
      });
  });
  handlerRegistered = true;
};
export const handleReaderTransactions = (state, action, dispatch) => {
  switch (action.type) {
    case fromPayment.CANCEL_PAYMENT:
      iosBridge.callHandler('payworks://close');
      break;

    case fromBridge.READER_TRANSACTION_SUCCESS:
      dispatch(paymentActions.readerTransactionSuccess(action.payload));
      break;

    case fromBridge.READER_TRANSACTION_FAIL:
      dispatch(paymentActions.readerTransactionFail(action.payload));
      break;

    case fromBridge.REGISTER_PAYMENT_HANDLER: {
      registerHandler(dispatch);
      break;
    }

    default:
  }
};

export const handleHandoff = (state, action, dispatch) => {
  switch (action.type) {
    case HANDOFF_UPDATE_KIOSK_CART: {
      publishToClient(state.auth.shop, getCurrentUserId(state), bridgeActions.handoffUpdateKioskCart(action.payload));
      break;
    }

    case HANDOFF_RESET_KIOSK_CART: {
      publishToClient(state.auth.shop, getCurrentUserId(state), bridgeActions.handoffResetKioskCart());
      break;
    }

    case HANDOFF: {
      if (nonBlockingHandoffActive(state)) {
        publishToClient(state.auth.shop, getCurrentUserId(state), bridgeActions.handoff(action.payload));
      }

      break;
    }

    case fromBridge.HANDOFF_BUSY:
      dispatch(handoffActions.handoffBusy(action.payload));
      break;

    case fromBridge.HANDOFF_SUCCESS:
      dispatch(handoffActions.handoffSuccess(action.payload));
      break;

    case fromBridge.HANDOFF_ERROR:
      dispatch(handoffActions.handoffError(action.payload));
      break;

    default:
  }
};

export const handleReceipt = (state, action, dispatch) => {
  switch (action.type) {
    case fromBridge.HIDE_RECEIPT:
      dispatch(hideReceipt());
      break;

    default:
  }
};

export const handleChangeShop = (state, action) => {
  if (action.type === fromSettings.SET_MERCHANT_INFO) {
    iosBridge.callHandler('shop://change', {
      cashDrawerEnabled: state.auth.cashDrawerEnabled,
      wifiReaderEnabled: Boolean(get(action, 'payload.ipAddress')),
      payworksProcessor: state.auth.payworksProcessor,
    });
  }
};

export const handleCashDrawer = (state, action) => {
  switch (action.type) {
    case fromCashRegister.OPEN_CASH_REGISTER_DRAWER:
      iosBridge.callHandler('register://open');
      break;

    default:
  }
};

export const handleLogout = (action) => {
  if (action.type === fromAuth.AUTH_DISCARD_USER && !action.fromInit) {
    iosBridge.callHandler('log://out');
  }
};

let isPaymentHandled = false;
let intentHandlerRegistered = false;
const registerPaymentIntentHandler = (dispatch) => {
  if (!iosBridge.isInitialized() || intentHandlerRegistered) {
    return;
  }

  intentHandlerRegistered = true;
  iosBridge.registerHandler('webreader://process', (response = {}) => {
    if (response.paymentIntentSecret) {
      isPaymentHandled = false;
      dispatch(webreaderActions.setExternalPaymentInfo({
        strategy: 'pay',
        paymentIntentSecret: response.paymentIntentSecret,
      }));
    }

    if (response.chargeId) {
      isPaymentHandled = false;
      dispatch(webreaderActions.setExternalPaymentInfo({
        strategy: 'refund',
        amount: response.amount,
        chargeId: response.chargeId,
      }));
    }
  });
  iosBridge.callHandler('webreader://ready');
};

let canRegisterProcessor = false;
export const handleWebreaderProcessor = (state, action, dispatch) => {
  if (action.type === CHANGE_SHOP) {
    // change shop is dispatched after we fetch session
    // and it resets store to the initial state
    // that's why  we need to register payment processor after we have shop info set
    // so payment data is not eliminated by CHANGE_SHOP
    canRegisterProcessor = true;
  }

  if (canRegisterProcessor) {
    // register native web terminal payment processor handlers
    registerPaymentIntentHandler(dispatch);
  }

  // when cancelling processing web terminal sends an additional error event
  // restrict the processor to send only one result per payment intent
  if (isPaymentHandled) {
    return;
  }

  switch (action.type) {
    case fromTerminal.PROCESS_PAYMENT_SUCCESS:
      isPaymentHandled = true;

      if (action.strategy === 'pay') {
        iosBridge.callHandler('webreader://success', { paymentIntentId: action.payload.id });
      }

      if (action.strategy === 'refund') {
        iosBridge.callHandler('webreader://success', action.payload);
      }

      break;
    case fromTerminal.WEBREADER_ERROR:
      isPaymentHandled = true;
      iosBridge.callHandler('webreader://error', action.payload.error);
      break;
    case fromTerminal.CANCEL_TRANSACTION:
    case fromWebreader.SELECT_READER_CANCEL:
      isPaymentHandled = true;
      iosBridge.callHandler('webreader://cancel');
      break;
    default:
      break;
  }
};
